module.exports = __webpack_public_path__ + "img/mysql.dd817ea4.png";